import React from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import './AdminSidebar.css';

const AdminSidebar = ({ onNavigate }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const items = [
    { path: '/admin', label: 'Dashboard', icon: 'space_dashboard', matchPaths: ['/admin'] },
    {
      path: '/admin/vendors',
      label: 'Vendors',
      icon: 'storefront',
      matchPaths: ['/admin/vendors', '/admin/vendor-security', '/admin/vendor-requirements', '/admin/requirement-dispatches'],
    },
    {
      path: '/admin/suppliers',
      label: 'Suppliers',
      icon: 'warehouse',
      matchPaths: ['/admin/suppliers', '/admin/supplier-dispatches'],
    },
    {
      path: '/admin/government-portal',
      label: 'Government Portal',
      icon: 'account_balance',
      matchPaths: ['/admin/government-portal'],
    },
    {
      path: '/admin/employees',
      label: 'Employees',
      icon: 'group',
      matchPaths: ['/admin/employees', '/admin/attendance-summary', '/admin/attendance-live', '/admin/employee-tracking-history', '/admin/attendance-report', '/admin/worktime-summary', '/admin/departments-roles'],
    },
    {
      path: '/admin/certificates',
      label: 'Certificates & ID Cards',
      icon: 'workspace_premium',
      matchPaths: ['/admin/certificates', '/admin/supplier-certificates', '/admin/idcards'],
    },
    {
      path: '/admin/contractors',
      label: 'Contractors',
      icon: 'engineering',
      matchPaths: ['/admin/contractors', '/admin/contractor-rates'],
    },
    { path: '/admin/products', label: 'Products', icon: 'inventory_2' },
    { path: '/admin/notifications', label: 'Notifications', icon: 'notifications_active' },
    {
      path: '/admin/payouts',
      label: 'Payments',
      icon: 'payments',
      matchPaths: ['/admin/payouts', '/admin/payment-history', '/admin/payments/phonepe', '/admin/phonepe-transactions', '/admin/payroll'],
    },
    {
      path: '/admin/whatsapp',
      label: 'WhatsApp',
      icon: 'forum',
      matchPaths: ['/admin/whatsapp', '/admin/whatsapp/history'],
    },
    {
      path: '/admin/reports',
      label: 'Reports',
      icon: 'query_stats',
      matchPaths: ['/admin/reports'],
    },
    {
      path: '/admin/workflow-map',
      label: 'Workflow Map',
      icon: 'account_tree',
      matchPaths: ['/admin/workflow-map'],
    },
    {
      path: '/admin/meta-leads',
      label: 'Meta Leads',
      icon: 'campaign',
      matchPaths: ['/admin/meta-leads'],
    },
    { path: '/admin/profile', label: 'Profile', icon: 'account_circle' },
  ];

  const isItemActive = (item) => {
    if (item.path === '/admin') {
      return currentPath === '/admin' || currentPath === '/admin/';
    }
    const paths = item.matchPaths || [item.path];
    return paths.some((p) => currentPath === p || currentPath.startsWith(`${p}/`));
  };

  return (
    <div className="admin-sidebar-wrap">
      <Nav className="flex-column admin-nav-list">
        {items.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/admin'}
            onClick={onNavigate}
            className={`sidebar-link admin-nav-link nav-link ${isItemActive(item) ? 'active' : ''}`}
          >
            <span className="material-symbols-outlined">{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </Nav>
    </div>
  );
};

export default AdminSidebar;
